import type { Existencia } from "@/lib/supabase";

/** Escapa celdas para CSV y neutraliza inyección de fórmulas (= + - @). */
export function celdaCsv(v: unknown): string {
  if (v === null || v === undefined) return "";
  let s = String(v);
  if (/^[=+\-@]/.test(s)) s = `'${s}`;
  if (/[",\n;]/.test(s)) s = `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function inventarioACsv(filas: Existencia[], conErp: boolean): string {
  const cab = ["Clave", "Nombre", "Unidad", "Almacen", "Zona", "Ubicacion", "Fisico", "Minimo", "Sugerencia compra", "Rotacion esperada", "Periodo dias", "Dias cobertura", "Estado", "Ultimo conteo", "Contado por"];
  if (conErp) cab.push("Existencia sistema", "Diferencia");
  const lineas = [cab.join(",")];
  for (const e of filas) {
    const fila = [e.sku, e.nombre, e.unidad, e.almacen_nombre, e.zona_codigo, e.ubicacion, e.cantidad_fisica, e.stock_minimo, e.sugerencia_compra, e.consumo_esperado, e.periodo_dias, e.dias_cobertura, e.estado, e.ultimo_conteo_en, e.ultimo_conteo_por_nombre];
    if (conErp) fila.push(e.existencia_erp, e.diferencia_erp);
    lineas.push(fila.map(celdaCsv).join(","));
  }
  return "﻿" + lineas.join("\r\n");
}

export function exportarCsv(nombre: string, filas: Existencia[], conErp: boolean) {
  const blob = new Blob([inventarioACsv(filas, conErp)], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = nombre; a.click();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
